import { ProcessListItemDto, SortDirectionDto } from '@/api/generated';
import { CustomTableStateModel } from '@/components/table/model/CustomTableState.model.ts';
import {
  initialProcessListSearchFormModel,
  ProcessesListSearchFormModel,
} from '@/views/processes/list/model/ProcessesListSearchForm.model.ts';

export type ProcessesListTableState = CustomTableStateModel<
  string,
  ProcessesListSearchFormModel,
  ProcessListItemDto
>;

export const initialProcessesListTableState: ProcessesListTableState = {
  data: {
    items: [],
    totalPages: 0,
    totalResults: 0,
  },
  page: 0,
  pageSize: 10,
  params: initialProcessListSearchFormModel,
  sortBy: '',
  sortOrder: SortDirectionDto.Asc,
};
